export default {
  path: 'centrallevelcomplaintsstatus',
  component: () =>
    import('@/views/dashboard/CentralLevelComplaintsStatus/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'centrallevelcomplaintsstatus',
      component: () =>
        import('@/views/dashboard/CentralLevelComplaintsStatus/Main.vue'),
    },
  ],
}
